import { useState } from 'react';
import { deleteJobPayment } from '../api/jobPayments';

/**
 * Hook for deleting a job payment
 */
export function useDeleteJobPayment() {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deletePayment = async (jobId: number, paymentId: number): Promise<boolean> => {
    setIsDeleting(true);
    setError(null);
    try {
      await deleteJobPayment(jobId, paymentId);
      return true;
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to delete job payment');
      return false;
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    deletePayment,
    isDeleting,
    error,
  };
}
